export const wrapperSx = {
    '& .MuiInputBase-input': {
        display: 'flex',
        textAlign: 'center',
        height: '55px'
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderRadius: '4px',
            borderColor: '#3B8511',
            borderWidth: '2px',
        },
        '&:hover fieldset': {
            borderRadius: '4px',
            borderColor: '#3B8511',
            borderWidth: '2px',
        },
        '&.Mui-focused fieldset': {
            borderRadius: '4px',
            borderColor: '#3B8511',
            borderWidth: '2px',
        },
    },
};

export const fieldIntroSx = {marginBottom: 0};

export const hiddenSx = {
    '& legend': {display: 'none', border: 'none'},
    '& fieldset': {top: 0, border: 0},
};

export const inputProps = {
    style: {
        fontSize: '2rem',
        fontWeight: 700,
        fontFamily: 'var(--font-family-bold)',
        paddingTop: '2px',
        paddingBottom: '2px',
        paddingRight: '4px',
        paddingLeft: '4px',
        flexDirection: 'column',
        justifyContent: 'center',
        flexShrink: '0',
        height: '55px'
    }
} as any;